package fr.frux.navigation

/**
 * Onglet « maison » d'une zone (spec 2026-09-10 §4, lot 2) : celui que le rail éclaire quand
 * l'écran courant n'est pas un onglet et ne vient pas d'un onglet de la même zone. La carte est
 * derrière toute colonne de `MapZone`, donc Explorer. La pleine zone n'héberge que des écrans
 * du profil (réglages, notifications), donc Profil.
 */
fun LayoutZone.homeTab(): Route =
    when (this) {
        LayoutZone.MapChromeZone, LayoutZone.MapZone, LayoutZone.EntryZone -> Route.Map
        LayoutZone.FullZone -> Route.Profile
    }

/**
 * Onglet sélectionné dans le rail grand écran pour une pile donnée.
 *
 * Le dernier onglet de la pile reste sélectionné tant que l'écran courant vit dans la même zone
 * que lui : une fiche de récolte ouverte depuis Récoltes garde Récoltes, les Réglages gardent
 * Profil. Dès que l'écran courant change de zone (« Ajouter un arbre » depuis Profil s'ouvre en
 * colonne sur la carte), l'onglet maison de sa zone prend le relais : le rail dit ce que l'on
 * voit, pas d'où l'on vient.
 */
fun railSelection(backStack: List<Route>): Route {
    val home = backStack.lastOrNull()?.layoutZone()?.homeTab() ?: Route.Map
    val lastTab = backStack.lastOrNull { it.shouldShowBottomNav() }
    return if (lastTab != null && lastTab.layoutZone().homeTab() == home) lastTab else home
}
